import { isDefined } from "@clipboard-health/util-ts";
import { useEffect } from "react";

import { APP_V2_APP_EVENTS, logError } from "../../../../lib/analytics";
import type { BundleShiftPay } from "../types";

interface UseLogMissingBundleShiftPaysProps {
  shifts: ReadonlyArray<{ id: string }>;
  bundleShiftPays: Map<string, BundleShiftPay>;
  isLoading: boolean;
}

export function useLogMissingBundleShiftPays(props: UseLogMissingBundleShiftPaysProps) {
  const { shifts, bundleShiftPays, isLoading } = props;

  useEffect(() => {
    if (isLoading) {
      return;
    }

    for (const shift of shifts) {
      if (!isDefined(bundleShiftPays.get(shift.id))) {
        logError(APP_V2_APP_EVENTS.SHIFT_BUNDLE_NO_SHIFT_PAY_FOUND_FAILURE, {
          error: new Error("No total pay found for shift"),
          metadata: { shiftId: shift.id },
        });
      }
    }
  }, [isLoading, shifts, bundleShiftPays]);
}
